import { renderSomethingWentWrong } from '@utils';

const OTPErrorHandler = ({
  form,
  showAlert,
  errorReporter,
  // TODO: Remove once UnusualAccessUnblock migrates from v1 (CANT_RESEND_TOKEN)
  // to v2 (CANNOT_RESEND_TOKEN).
  canResendErrorCode,
  onExtraError
}) => apiError => {
  if (apiError.code === canResendErrorCode) {
    showAlert(
      'El código ya fue enviado. Espera unos momentos antes de solicitar uno nuevo.',
      'WARNING'
    );
  } else if (apiError.code === 'INVALID_TOKEN') {
    form.addError({ field: 'code', message: 'El código temporal ha expirado' });
  } else if (apiError.code === 'INVALID_CODE') {
    form.addError({
      field: 'code',
      message: 'El código temporal no coincide: verifica que sea correcto.'
    });
  } else if (apiError.code === 'INVALID_LATITUDE') {
    form.addError({ field: 'code', message: 'La latitud de tu ubicación es inválida' });
  } else if (apiError.code === 'INVALID_LONGITUDE') {
    form.addError({ field: 'code', message: 'La longitud de tu ubicación es inválida' });
  } else if (apiError.code === 'UNEXPECTED_ERROR') {
    showAlert(
      'Hubo un problema al comunicarnos con nuestros servicios. Intente de nuevo o más tarde.',
      'ERROR'
    );

    errorReporter.critical(apiError);
  } else if (!onExtraError?.(apiError)) {
    renderSomethingWentWrong();

    errorReporter.critical(apiError);
  }
};

export default OTPErrorHandler;
